function _getQueryString(obj, prefix) {
  const pairs = [];
  for (let key in obj) {
    if (!obj.hasOwnProperty(key)) {
      continue;
    }
    const value = obj[key];
    const enkey = encodeURIComponent(key);
    let pair;
    if (typeof value === "object") {
      if (Array.isArray(value)) {
        pair = value.map((item) => {
          return _getQueryString(
            item,
            prefix ? `${prefix}[${enkey}][]` : `${enkey}[]`
          );
        }).join("&");
      } else {
        pair = _getQueryString(value, prefix ? `${prefix}[${enkey}]` : enkey);
      }
    } else {
      pair = (prefix ? `${prefix}[${enkey}]` : enkey) + "=" + encodeURIComponent(value);
    }
    pairs.push(pair);
  }
  return pairs.join("&");
}
async function suggest(params, renderSelectors) {
  let requestResponse;
  return fetch(
    window.Shopify.routes.root + `search/suggest?${_getQueryString(params)}`
  ).then((response) => {
    requestResponse = response;
    return response.text();
  }).then((text) => {
    if (!requestResponse.ok) {
      throw new Error(`${requestResponse.status}: ${text}`);
    }
    renderSelectors.forEach((renderSelector) => {
      const resultsMarkup = new DOMParser().parseFromString(text, "text/html").querySelector(renderSelector).innerHTML;
      document.querySelector(renderSelector).innerHTML = resultsMarkup;
    });
  }).catch((error) => {
    console.error(error);
  });
}
async function addItem(variantId, quantity = 1, subscriptionPlanId = null, customProperties = {}) {
  const lineItem = {
    id: variantId,
    quantity,
    properties: customProperties
  };
  if (subscriptionPlanId) {
    lineItem.selling_plan = subscriptionPlanId;
  }
  try {
    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ items: [lineItem] })
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || "An error occurred while adding the product to the cart");
    }
    console.log("Product added to cart:", data);
    return data;
  } catch (error) {
    console.error("Error adding product to cart:", error.message);
    return false;
  }
}
async function addItems(items) {
  try {
    const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ items })
    });
    const data = await response.json();
    if (response.ok) {
      console.log("Products added to cart:", data);
    } else {
      throw new Error(
        data.message || "An error occurred while adding the products to the cart"
      );
    }
  } catch (error) {
    console.error("Error adding products to cart:", error.message);
  }
}
async function getAll() {
  try {
    const response = await fetch(window.Shopify.routes.root + "cart.js", {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    });
    const data = await response.json();
    if (response.ok) {
      console.log("Cart contents:", data);
      return data;
    } else {
      throw new Error(
        data.message || "An error occurred while retrieving the cart"
      );
    }
  } catch (error) {
    console.error("Error retrieving cart:", error.message);
    throw error;
  }
}
async function updateItem(variantId, quantity) {
  try {
    const updates = {
      [variantId]: quantity
    };
    const response = await fetch(
      window.Shopify.routes.root + "cart/update.js",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ updates })
      }
    );
    const data = await response.json();
    if (response.ok) {
      console.log("Cart updated:", data);
      return data;
    } else {
      throw new Error(
        data.message || "An error occurred while updating the cart"
      );
    }
  } catch (error) {
    console.error("Error updating cart:", error.message);
    throw error;
  }
}
async function updateItems(updates) {
  try {
    const response = await fetch(
      window.Shopify.routes.root + "cart/update.js",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ updates })
      }
    );
    const data = await response.json();
    if (response.ok) {
      console.log("Cart updated:", data);
      return data;
    } else {
      throw new Error(
        data.message || "An error occurred while updating the cart"
      );
    }
  } catch (error) {
    console.error("Error updating cart:", error.message);
    throw error;
  }
}
async function updateAttributes(attributes) {
  try {
    const response = await fetch(
      window.Shopify.routes.root + "cart/update.js",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ attributes })
      }
    );
    const data = await response.json();
    if (response.ok) {
      console.log("Cart updated:", data);
      return data;
    } else {
      throw new Error(
        data.message || "An error occurred while updating the cart"
      );
    }
  } catch (error) {
    console.error("Error updating cart:", error.message);
    throw error;
  }
}
async function changeItem(variantId, quantity, subscriptionPlanId = null, customProperties = {}) {
  try {
    const change = {
      id: variantId,
      quantity,
      properties: customProperties
    };
    if (subscriptionPlanId) {
      change.selling_plan = subscriptionPlanId;
    }
    const response = await fetch(
      window.Shopify.routes.root + "cart/change.js",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(change)
      }
    );
    const data = await response.json();
    if (response.ok) {
      console.log("Cart item changed:", data);
      return data;
    } else {
      throw new Error(
        data.message || "An error occurred while changing the cart item"
      );
    }
  } catch (error) {
    console.error("Error changing cart item:", error.message);
    throw error;
  }
}
async function clear() {
  try {
    const response = await fetch(window.Shopify.routes.root + "cart/clear.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      }
    });
    const data = await response.json();
    if (response.ok) {
      console.log("Cart cleared:", data);
      return data;
    } else {
      throw new Error(
        data.message || "An error occurred while clearing the cart"
      );
    }
  } catch (error) {
    console.error("Error clearing cart:", error.message);
    throw error;
  }
}
const cart = {
  addItem,
  addItems,
  getAll,
  updateItem,
  updateItems,
  updateAttributes,
  changeItem,
  clear
};
const shopifyAPI = {
  suggest,
  cart
};
export {
  shopifyAPI as s
};
//# sourceMappingURL=api.16eded5c.chunk.js.map
